import { InjectionToken } from '@angular/core';
import {
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { FieldType, FilterType } from '@ideapa/common-interfaces';

export const ENTITY = 'programma';
export const ENTITY_PLURAL = 'programmi';
export const gridColumns: EntityListField[] = [
  {
    elementLabel: 'Codice Missione',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'missione.codice',
    sortable: true,
    sort: 'asc',
    minWidth: 200,
    maxWidth: 210,
  },
  {
    elementLabel: 'Missione',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'missione.descrizione',
    sortable: true,
  },
  {
    elementLabel: 'Codice Programma',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'codice',
    sortable: true,
    sort: 'asc',
    minWidth: 200,
    maxWidth: 210,
  },
  {
    elementLabel: 'Programma',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'descrizione',
  },
];
export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
